export var GET_IN_TOUCH_REQUEST_TYPES;
(function (GET_IN_TOUCH_REQUEST_TYPES) {
    GET_IN_TOUCH_REQUEST_TYPES["error"] = "Error";
    GET_IN_TOUCH_REQUEST_TYPES["improvementSuggestion"] = "Improvement Suggestion";
    GET_IN_TOUCH_REQUEST_TYPES["generalQuestion"] = "General Question";
    GET_IN_TOUCH_REQUEST_TYPES["verificationRequest"] = "Verification Request";
    GET_IN_TOUCH_REQUEST_TYPES["dataDispute"] = "Data Dispute";
    GET_IN_TOUCH_REQUEST_TYPES["PrivacyRelatedInquiry"] = "Privacy Related Inquiry";
})(GET_IN_TOUCH_REQUEST_TYPES || (GET_IN_TOUCH_REQUEST_TYPES = {})); // TODO 8base: make enum in sendGetHelpToClearVerifyStaff.ts
export var GET_IN_TOUCH_DATA_FIELDS;
(function (GET_IN_TOUCH_DATA_FIELDS) {
    GET_IN_TOUCH_DATA_FIELDS["requestType"] = "requestType";
    GET_IN_TOUCH_DATA_FIELDS["description"] = "description";
    GET_IN_TOUCH_DATA_FIELDS["verificationRequest"] = "verificationRequest";
    GET_IN_TOUCH_DATA_FIELDS["dataDispute"] = "dataDispute";
    GET_IN_TOUCH_DATA_FIELDS["attachments"] = "attachments";
})(GET_IN_TOUCH_DATA_FIELDS || (GET_IN_TOUCH_DATA_FIELDS = {}));
//# sourceMappingURL=getInTouch.js.map